import { AnalyticsService } from './../analytics/analytics.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Contribution, ThankYouCampaign } from '../track/contribution';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistryService } from '../registry/registry.service';
import { AuthService, User } from '../user/auth.service';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { TrackedGift } from '../payment/tracked-gift';
import { SettingsService } from '../settings/settings.service';
import { Registry } from '../registry/registry';
import { environment } from '../../environments/environment';
import { PersonalTempCreateModeComponent } from '../personal-temp-createmode/personal-temp-createmode.component';

declare var Stripe;

@Component({
  selector: 'app-track-detail',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit, AfterViewInit {
  prices: any[];
  pricePerCard:number;
  public hitchdForm: FormGroup;
  errorMessage: string;
  selectedQty: number;
  design: string;
  selectedTemplateImageUrl: string;
  thankType: string;
  digitalThankYouMsg:string;
  contributions: Contribution[];
  symbol: string;
  invalidDigitalCardMsg = false;
  processing = false;
  faq = false;
  greeting:string;
  artworkId: string;
  loaded = false;
  mode:string;
  sentDate: Date ;
  maxDate: Date ;
   minDate: Date
  designs = [
    {
        "url": "/assets/public/images/cards/090f262f-fdb7-fa7a-b53f-c866fd83e2bb.png",
        "id": "090f262f-fdb7-fa7a-b53f-c866fd83e2bb",
        "type": "Landscape Card"
    },
    {
        "url": "/assets/public/images/cards/0d1fc930-241b-ff7c-b853-0e4ff8e75fc1.png",
        "id": "0d1fc930-241b-ff7c-b853-0e4ff8e75fc1",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/23a206cf-72c8-5ae0-83f7-18a3feb22b47.png",
        "id": "23a206cf-72c8-5ae0-83f7-18a3feb22b47",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/24cfd78e-fb76-d879-a018-aa8adb4662b8.png",
        "id": "24cfd78e-fb76-d879-a018-aa8adb4662b8",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/35d19c09-e50d-8165-7ebe-1253ee887e82.png",
        "id": "35d19c09-e50d-8165-7ebe-1253ee887e82",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/36b86142-4963-221a-a472-40e02259eed1.png",
        "id": "36b86142-4963-221a-a472-40e02259eed1",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/3b5ba030-b182-4a43-c580-c6b5bf685786.png",
        "id": "3b5ba030-b182-4a43-c580-c6b5bf685786",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/3fb46466-1aa2-c1dc-ec21-2e519d50092e.png",
        "id": "3fb46466-1aa2-c1dc-ec21-2e519d50092e",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/6ff288fb-17df-a4f0-bb09-fdd2547d2f7d.png",
        "id": "6ff288fb-17df-a4f0-bb09-fdd2547d2f7d",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/7c6e6772-5643-4ef3-7ba5-23af73434cf7.png",
        "id": "7c6e6772-5643-4ef3-7ba5-23af73434cf7",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/8b275063-d120-1f47-ce38-3e6a1485162a.png",
        "id": "8b275063-d120-1f47-ce38-3e6a1485162a",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/8b35a297-db1e-3e89-9b26-328b4145f732.png",
        "id": "8b35a297-db1e-3e89-9b26-328b4145f732",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/8f6f4e06-ec3d-4a95-a8b9-4a620e936948.png",
        "id": "8f6f4e06-ec3d-4a95-a8b9-4a620e936948",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/9ddbd909-891b-4b4c-baed-973bf573d96d.png",
        "id": "9ddbd909-891b-4b4c-baed-973bf573d96d",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/cb76e6e0-193a-43c7-5ae9-fb3af26634f8.png",
        "id": "cb76e6e0-193a-43c7-5ae9-fb3af26634f8",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/d1650800-3c73-3e2b-411f-7beed4482c16.png",
        "id": "d1650800-3c73-3e2b-411f-7beed4482c16",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/d6aaa507-d75d-9122-558d-f2460bebe5df.png",
        "id": "d6aaa507-d75d-9122-558d-f2460bebe5df",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/dc217cc8-e590-9aba-a37f-0e9595572c6b.png",
        "id": "dc217cc8-e590-9aba-a37f-0e9595572c6b",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/e9693731-4ad9-1193-24e9-57dc7039584b.png",
        "id": "e9693731-4ad9-1193-24e9-57dc7039584b",
        "type": "Landscape Card"
    },
    {
      "url": "/assets/public/images/cards/f3863e90-dc99-62d4-4d26-dea0478ec9a3.png",
        "id": "f3863e90-dc99-62d4-4d26-dea0478ec9a3",
        "type": "Landscape Card"
    }
];
euCountries = [
  'AL',
  'AD',
  'AM',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FO',
  'FI',
  'FR',
  'GB',
  'GE',
  'GI',
  'GR',
  'HU',
  'HR',
  'IE',
  'IS',
  'IT',
  'LT',
  'LU',
  'LV',
  'MC',
  'MK',
  'MT',
  'NO',
  'NL',
  'PO',
  'PT',
  'RO',
  'RU',
  'SE',
  'SI',
  'SK',
  'TR',
  'UA',
  'VA'
];
  price: number;
  step = 1;
  sends: any[];
  thankYouCampaign: ThankYouCampaign;
  type : string;
  cardsLeft:number;
  selectedPackage: number;
  contributionId: string;
  bundle:string;
  contribution: Contribution;
  uploadedImage: string;
  user: User;
  registry: Registry;
  uploadText = 'Upload image from your trip';
  country: string;
  isEu: boolean;
  sendThankYouMsg:string;
  currentPrice: number;
  errors: string;
  yourErrors:string;
  tempCardMessage: string;
  pricing: any =

  {
  AU: { country: 'AU', small: 90 ,  med: 200, large: 350, xlarge: 450   },
  GB: { country: 'GB', small: 50 ,  med: 112, large: 200, xlarge: 262.5   },
  US: { country: 'US', small: 80 ,  med: 175, large: 300, xlarge: 375   },
  CA: { country: 'CA', small: 90 ,  med: 200, large: 350 , xlarge: 450   },
  NZ: { country: 'NZ', small: 120 ,  med: 275, large: 500  , xlarge: 650   },
  EU: { country: 'DE', small: 65 ,  med: 150, large: 275  , xlarge: 375   },
  };
  pricingPerCard: any =

  {
  AU: { country: 'AU', price_per_card: 5.5   },
  GB: { country: 'GB', price_per_card: 3.5   },
  US: { country: 'US', price_per_card: 4   },
  CA: { country: 'CA', price_per_card: 5    },
  NZ: { country: 'NZ', price_per_card: 6.5    },
  EU: { country: 'DE', price_per_card: 3.5   },
  };
  demoMode: boolean;

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _fb: FormBuilder,
    private _paymentService: PaymentService,
    private _analyticsService: AnalyticsService
  ) {

    document.title = 'Thank you | Hitchd';
    this._analyticsService.trackEvent('Thank you page viewed', {});
    this.mode = null;
    this._route.params

      .subscribe(params => {

       // this.getDesigns();
        this.setDesign(this.designs[0]);
        this.contributionId = params['paymentId'];
        this.tempCardMessage = localStorage.getItem('last-card_'+this.contributionId);
        if (this.contributionId == 'explore') {
          this.demoMode = true;
          this.loaded = true;
          this._registryFirebaseService.killLoader();
        }
          // this._registryFirebaseService.currentRegistry.subscribe(registry => {
          //   if (registry) {
          //     this.symbol = registry.symbol;
          //   }

          //});
        if (this.tempCardMessage &&  location.search.includes('success')){
          this.mode = 'cards';
          this.sendThankYouMsg = this.tempCardMessage;

            this.step = 3;

        }


        this._registryFirebaseService.currentRegistry.subscribe(registry => {
          this.registry = registry;
          this._registryFirebaseService.killLoader();
        });
              this._authService.user.subscribe(user => {
          if (!user) {
            return;
          } else {
            this.user = user;
          }
          if(this.demoMode){
            this.cardsLeft = 5;
          }
          this._registryFirebaseService.getCardSends(user.userId).take(1).subscribe(sends=>{
            ;
            if (sends.length){
              this.sends = sends;
              let card = sends.filter(x=>x.contributionId == this.contributionId)[0];
              if (card){

                  this._router.navigate(['/registry/contributions', this.contributionId], {skipLocationChange: true});


              }
             }



if(this.hitchdForm && this.sends && this.sends.length){

    let send = this.sends[0];
     this.hitchdForm.controls['yourFirstName'].setValue(send.sender.firstName);
     this.hitchdForm.controls['yourLastName'].setValue(send.sender.lastName);
     this.hitchdForm.controls['yourAddressLine1'].setValue(send.sender.address);
     this.hitchdForm.controls['yourCity'].setValue(send.sender.city);
     this.hitchdForm.controls['yourState'].setValue(send.sender.region);
     this.hitchdForm.controls['yourPostcode'].setValue(send.sender.postcode);
     this.hitchdForm.controls['yourCountry'].setValue(send.sender.country);

}


          });


          // ;
          this._registryFirebaseService.initGiftsForUser(user);
          this._registryFirebaseService.currentGifts.subscribe(gifts => {

            if (gifts) {



              this._registryFirebaseService.getContributions(gifts).subscribe(contributions => {
                if (contributions) {
                  this.contribution = contributions.filter(x => x.id === this.contributionId)[0];
                  if (this.contribution) {



                    this.uploadedImage = this.contribution.coupleThankYouImageUrl;
                    // if (!this.contribution.coupleFee){
                    //   this.contribution.coupleFee = 0;
                    // }

                    // if (!this.contribution.guestFee){
                    //   this.contribution.coupleFee = 0;
                    // }
                  }
                  if (this.contribution && !this.contribution.seen) {

                    this._registryFirebaseService.updateContribution(this.contribution.id, this.contribution.coupleThankYou
                      , this.contribution.coupleThankYouImageUrl, true, true);

                  }

                  this.loaded = true;



                }
              });

              this._registryFirebaseService.currentRegistry.subscribe(registry => {
                if (registry) {
                  
                  this.symbol = registry.symbol;
                  this.country = this.registry.country;
                  this.shouldSetAsEuForPayment();
                }

              });

            }
          });
        });
      });




    

      this.country = this.registry.country;      
      this.isEu = this.isEuCountry(this.country);

      this.shouldSetAsEuForPayment();
      let pricePerCard = this.pricingPerCard[this.country];
      if(!pricePerCard){
        //catch all for unsported countries to stop white screen error and show EUR currency for cards
        this.country = "EU"
        this.isEu = true;
        this.symbol = "€";
        pricePerCard = this.pricingPerCard[this.country];
      }

      if (!this.currentPrice && this.isEu){
        this.currentPrice = this.pricingPerCard['EU'];
      } else if (!this.currentPrice && !this.isEu) {
        this.currentPrice = this.pricingPerCard['US'];
      }
      
      this.pricePerCard = pricePerCard.price_per_card;

       this.prices = [
        {  price:  this.pricePerCard* 1,   qty: 1},
        {  price:  this.pricePerCard * 2,   qty: 2},
        {  price:  this.pricePerCard * 3,   qty: 3},
        {  price:  this.pricePerCard * 4,   qty: 4},
        {  price:  this.pricePerCard * 5,   qty: 5},
        {  price:  this.pricePerCard * 10,   qty: 10},
        {  price:  this.pricePerCard * 15,   qty: 15},
        {  price:  this.pricePerCard * 20,   qty: 20},
        {  price:  this.pricePerCard * 25,   qty: 25},
        {  price:  this.pricePerCard * 30,   qty: 30},
        {  price:  this.pricePerCard * 35,   qty: 35},
        {  price:  this.pricePerCard * 40,   qty: 40},
        {  price:  this.pricePerCard * 45,   qty: 45},
        {  price:  this.pricePerCard * 50,   qty: 50},
        {  price:  this.pricePerCard * 60,   qty: 60},
      ]

  }

shouldSetAsEuForPayment(){
  if (this.country == 'CH' || this.country == 'NO' ||this.country == 'SE' || this.country=='DK') {
    this.country = "EU"
    this.isEu = true;
    this.symbol = "€";
  }
}
  checkCardCredits(){

    return fetch(environment.firebase.clouldFunctionHost + '/checkCredits', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        registryId: this.registry.id,
        userId: this.registry.userId,
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log(data)
        //const data:any = result.json();
    //    let data:any =result.body;
        this.cardsLeft =  data.cardsLeft ;
    });

//     .then((result) => {
// ;


//     });
  }

  analyticsTrack(event){
    this._analyticsService.trackEvent(event, {});
  }

  clearIfEmpty(fieldName: string) {
    const field = this.hitchdForm.controls[fieldName];
    field.setValue('');
  }
  focusOut(fieldName: string, resetValue: string) {
    const field = this.hitchdForm.controls[fieldName];

  }

  next(step:number){


if (!this.cardsLeft && this.sendThankYouMsg){
localStorage.setItem('last-card_' + this.contributionId, this.sendThankYouMsg);
}
let analyticsEventName = '';
if (step === 1) {
  analyticsEventName = 'Thank you card - design selected';
} else if (step === 2) {
  analyticsEventName = 'Thank you card - message entered';
} else if (step === 3 && !this.faq  && !this.cardsLeft) {
  analyticsEventName = 'Thank you card - bundle options presented';
}
this._analyticsService.trackEvent(analyticsEventName, {contributionId: this.contributionId});


    this.step = step;
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 1;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    this.hitchdForm.markAsTouched();
  }


  thankYou(thankYouText: string, thankYouImageUrl: string) {
    this._registryFirebaseService.updateContribution(this.contributionId, thankYouText, thankYouImageUrl, true, false);

  }

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);
    const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById('introtext');
    //
    if (textarea) {
      textarea.value = textarea.value + '';
      this.expandTextArea(textarea);
    }

  }
  navigateToGift(url) {
    this._router.navigate(['/registry/' + url]
      , { queryParams: { from: 'contrib-detail' } });
  }
  handledUploadedImage(event: any) {
    if (event) {
      event = event + '?hex=ffffff';
    }
    this.uploadedImage = event;
  }

  getGiftUrlWithoutHex(imageUrl: string) {
    if (imageUrl) {
      return this._registryService.cleanImageUrlRemoveHex(imageUrl);
    }
  }

  color(imageUrl: string) {
    return this._registryService.getColor(imageUrl);
  }


  openUploader() {
if(this.demoMode){
  return;
}
    document.getElementById('file_input_id').click();
  }

  selectFirstName(fullName: string) {

    if (fullName) {
      return fullName.split(' ')[0];
    }
  }

  sendThanksViaCard() {
    if (!this.registry.paidThankyouCards || this.registry.availableThankYouCards == 0) {
      this._router.navigate(['/registry/thank-you-cards'])
    }
  }



 isEuCountry(country) {
  return this.euCountries.includes(country);
}
  ngOnInit() {

    this.hitchdForm = this._fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      addressLine1: [null,[Validators.required]],
      city: [null, [Validators.required]],
      postcode: [null, [Validators.required]],
      state: [null, [Validators.required]],
      country:[null, [Validators.required]],

      yourFirstName: [null, [Validators.required]],
      yourLastName: [null, [Validators.required]],
      yourAddressLine1: [null,[Validators.required]],
      yourCity: [null, [Validators.required]],
      yourPostcode: [null, [Validators.required]],
      yourState: [null, [Validators.required]],
      yourCountry:[null, [Validators.required]],

    });


    this.checkCardCredits();

  }
  selectPackage(bundle: string) {

this.bundle = bundle;
this.price = this.currentPrice[bundle];
this._analyticsService.trackEvent('Thank you card - bundle selected', {contributionId: this.contributionId,
  bundle: bundle, price: this.price, currency: this.registry.currency, country: this.registry.country});

}
  setDesign(design: any) {

    this.selectedTemplateImageUrl = design.url;
    this.artworkId = design.id;
  }

  purchasePackage() {
    this.upgradeAccount(this.selectedQty);

  }


  hideFaq() {
    this._analyticsService.trackEvent('Thank you card - faqs closed', {contributionId: this.contributionId});
    this.faq = false;
  }
  showFaq() {
    this._analyticsService.trackEvent('Thank you card - show faqs clicked', {contributionId: this.contributionId});
    this.faq = true;
  }
  submit() {
    if(this.demoMode){
      return;
    }
    if (this.digitalThankYouMsg) {
      this.processing = true;
      const message = this.digitalThankYouMsg;
      const paymentId = this.contributionId;
      this._registryFirebaseService.updateContribution(paymentId, message, this.uploadedImage, true, false);

      let guestName = this.contribution.guestName;
      if (this.contribution.wish && this.contribution.wish.fullname) {

        guestName = this.contribution.wish.fullname;
        if (this.contribution.wish.partnersName) {
          guestName = this.selectFirstName(this.contribution.wish.fullname) + ' & '
            + this.selectFirstName(this.contribution.wish.partnersName);
        }

      }


      let giftNames = '';
      for (let i = 0, len = this.contribution.cart.length; i < len; i++) {
        if (giftNames !== '' && i < (len - 1)) {
          giftNames = giftNames + ', ';
        } else if (len > 1 && i === (len - 1)) {
          giftNames = giftNames + ' and ';
        }
        giftNames = giftNames + this.contribution.cart[i].gift.title;
      }


      const emailRequest: any = {
        registryId: this.registry.id,
        giftNames: giftNames,
        guestNames: guestName,
        thankyouText: message,
        thankyouImage: this.uploadedImage,
        giftTotal: this.contribution.giftTotal,
        coupleNames: this.registry.firstName + ' & ' + this.registry.partnerFirstName,
        guestEmail: this.contribution.guestEmail,
        totalAmount: this.contribution.giftTotal + this.contribution.guestFee,
        guestFee: this.contribution.guestFee,
        symbol: this.registry.symbol
      };
      this._paymentService.SendThankYouEmail(JSON.stringify(emailRequest)).subscribe(x => {
        this._router.navigate(['/registry/contributions', this.contributionId]);
      });
    }

  }
  modelChanged(newObj) {
    // do something with new value
    const textarea = document.getElementById('thankyoudigital');

    this.fixedSize(textarea, null);
}


  fixedSize(textarea, event) {



    if (textarea.clientHeight < textarea.scrollHeight) {
this.invalidDigitalCardMsg = true;

    } else {
      this.invalidDigitalCardMsg = false;
    }
  }
sendThankYouCard(){

  this._authService.authToken().subscribe(token => {
this.yourErrors = null;
this.errors = null;


  this.processing = true;
  return fetch(environment.firebase.clouldFunctionHost + '/sendThankYouCard', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      registryId: this.registry.id,
      userId: this.registry.userId,
      thankYouMessage: this.sendThankYouMsg,
      frontImageUrl: this.selectedTemplateImageUrl,
      firstName: this.hitchdForm.controls['firstName'].value,
      lastName: this.hitchdForm.controls['lastName'].value,
      addressLine1: this.hitchdForm.controls['addressLine1'].value,
      city: this.hitchdForm.controls['city'].value,
      state: this.hitchdForm.controls['state'].value,
      postcode: this.hitchdForm.controls['postcode'].value,
      country: this.hitchdForm.controls['country'].value,
      yourFirstName: this.hitchdForm.controls['yourFirstName'].value,
      yourLastName: this.hitchdForm.controls['yourLastName'].value,
      yourAddressLine1: this.hitchdForm.controls['yourAddressLine1'].value,
      yourCity: this.hitchdForm.controls['yourCity'].value,
      yourState: this.hitchdForm.controls['yourState'].value,
      yourPostcode: this.hitchdForm.controls['yourPostcode'].value,
      yourCountry: this.hitchdForm.controls['yourCountry'].value,
      artworkId: this.artworkId,
      token: token,
      contributionId: this.contributionId
    }),
  }).then((result) => {

    this.checkCardCredits();
    if(result.status == 200){
          result.json().then(resultData=>{

            if (resultData.maxDate && resultData.minDate){
            this.sentDate = new Date(resultData.sentDate);
            this.maxDate = new Date(resultData.maxDate);
             this.minDate = new Date(resultData.minDate);

            }
          });
          this.step = 4;





if (this.tempCardMessage){
  localStorage.removeItem('last-card_'+this.contributionId);
}

    } else {

       result.json().then((responseData)=>{




        if (responseData && responseData.data && responseData.data["lines.0.recipient.region"]){
          this.errors = responseData.data["lines.0.recipient.region"];
        }
        if (responseData && responseData.data && responseData.data["lines.0.sender.region"]){
          this.yourErrors = responseData.data["lines.0.sender.region"];
        }





      this.processing = false;
    })}

  }).catch(ex=>{
    console.log(ex);
  });
});
}


getDesigns(){




  return fetch(environment.firebase.clouldFunctionHost + '/getThankYouTemplates', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    },
  }).then(response => response.json())
  .then(data => {
    this.designs = data;
    this.setDesign(this.designs[0]);

});
}

  upgradeAccount(qty: number) {
    (window as any).stripe = Stripe(environment.stripePublicKey, { });
    
    let total = qty * this.pricePerCard;

    //this.type = type;
    this.processing = true;
    return fetch(environment.firebase.clouldFunctionHost + '/createCheckoutSession', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: qty,
        total: total,
        userAgent: navigator.userAgent,
        url: location.href,
        locale: 'auto',
        registryId: this.registry.id,
        source: this.registry.source,
        campaign: this.registry.campaign,
        partnershipId: this.registry.partnershipId,
        userId: this.registry.userId,
        country: this.country,
        contributionId: this.contributionId,
        isEu: this.isEu,
        type: 'bundle_'+qty,
        email: this.user.email,

        paymentType: "cards"
      }),
    }).then((result) => {

      const reulst = result.json();
      reulst.then((x: any) => {
        const sessionId = x.sessionId;
        (window as any).stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (redirectResult) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
      //  return redirectResult.json();
      });


      }
      );
      //

    }


}




// WEBPACK FOOTER //
// ./src/app/thank-you/thank-you.component.ts